import Mock from './Mock';

export default class TimeEntryServiceMock {
  static getCurrentWeekTimeEntries() {
    return Mock.call();
  }

  static getWeekTimeEntriesFromDate() {
    return Mock.call();
  }

  static getTimeEntryById() {
    return Mock.call();
  }

  static addTimeEntry() {
    return Mock.call();
  }

  static deleteTimeEntry() {
    return Mock.call();
  }

  static saveTimeEntry() {
    return Mock.call();
  }

  static submit() {
    return Mock.call();
  }
}
